
import "./quality-control.css";
import packing1 from "../images/metal-packing-1.png"
import packing2 from "../images/metal-packing-2.jpg"


const Packing = () => {
    return (
        <>

            <div className="qc-container">
                <h1 className="qc-title">METAL PACKAGING</h1>

                <p className="qc-subtitle">IN-HOUSE METAL CANISTERS PRODUCTION</p>

                <div className="qc-image-wrapper">
                    <img
                        src={packing1}
                        alt="Quality Control"
                        className="qc-image"
                    />
                </div>

                 <div className="qc-content ">
                    <p>

                        We are proud to say that SCT Lubricants is one of the few factories all over the world that have got their own in-house metal canister production. That means we can never have delays due to package delivery issues. The new workshop was built in 2018 and since then over 70,000 canisters are being produced each day. 
                    </p>

                    <p>
                        It all starts with SOUDROUNIC Double Slitter where printed tinplates get cut into even bodies with precision of 1.01 mm. The output capacity is over 500 bodies per minute, which means that the machine can process over 7,500 printed metal sheets per hour.
                    </p>

                    <p>
                        After that the cut can bodies move onward to get welded and obtain the shape of a cylinder. Two SABATIER fully automatic tin can production lines work daily with an output speed of 80,000 cans per shift. Each machine is set up for 1 L or 0,5 L and 4 L or 5 L respectively.
                    </p>
                    <p>
                        When welding is over and a layer of lacquer is applied the cans move onward through a 3 m long oven so that the lacquer dries out and the welded surface does not get damaged or rusted.  
                    </p>
                </div>
            </div>
            <div className="qc-container">
                <div className="qc-image-wrapper">
                    <img
                        src={packing2}
                        alt="Quality Control"
                        className="qc-image"
                    />
                </div>

                <div className="qc-content">
                    <p>
                        The next step is to shape the welded metal sheets into cylinders. For that purpose a super sensitive laser body positioning system is used. It defines the weld and turns the item in a way so that the expander can form it into an even can.                        
                    </p>

                    <p>
                        The last phase is to seam the both sides of the can. The seam flanger applies the bottom lid, seams it up, turns the can upside down and applies the top lid. Every half an hour the machine operator takes a sample and checks the weld, the seams and tests it for leaks. It takes just a few minutes to make a can.
                    </p>

                    
                </div>

               
            </div>
        </>



    );
};

export default Packing;